export const DEVICE_NOT_FOUND_ERROR = "DEVICE_NOT_FOUND_ERROR";
export const DEVICE_UPDATE_ERROR = "DEVICE_UPDATE_ERROR";
